(ns superadmin.announcements.create-ocp.view
  (:require ["@mui/material/Autocomplete$default" :as Autocomplete]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/Chip$default" :as Chip]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/TextField$default" :as TextField]
            ["react-hook-form" :as rhf]
            [cljs-bean.core :refer [->clj]]
            [common.announcement.view]
            [common.form :as form]
            [common.ocp.view :refer [defocp ocp]]
            [common.queries :refer [use-mutation]]
            [common.util :refer [spread-props]]
            [common.widgets.form-field :refer [form-field]]
            [re-frame.core :as rf]
            [reitit.core :as r]
            [superadmin.announcements.queries :as q]
            [uix.core :as uix :refer [$ defui]]))

;; Avoid circular dependency
(defn available-routes []
  (clj->js (map str (r/route-names @(resolve 'common.router/router)))))

(defui ocp-footer [{:keys [^js formState getValues]}]
  (let [is-submitting (.-isSubmitting formState)
        is-valid (.-isValid formState)
        on-preview (uix/use-callback
                    (fn []
                      (let [{:keys [title content]} (->clj (getValues))]
                        (rf/dispatch [:modal/open {:id :announcement/notification
                                                   :props {:announcement {:title title
                                                                          :content content}}}])))
                    [getValues])]
    ($ Stack {:direction "row" :gap 1}
       ($ Button
          {:variant "outlined"
           :onClick on-preview
           :data-testid "announcement-preview"}
          "Preview")
       ($ Button
          {:type "submit"
           :variant "contained"
           :disabled (or (not is-valid) is-submitting)
           :data-testid "announcement-submit"}
          (if is-submitting "Creating..." "Create Announcement")))))

(defui announcement-ocp []
  (let [{:keys [control handleSubmit formState getValues]}
        (form/use-form #js {:mode "onChange"
                            :defaultValues #js {:title ""
                                                :content ""
                                                :routes #js []}})

        {:keys [mutate]} (use-mutation (q/create-announcement-mutation))

        on-submit (uix/use-callback
                   (fn [data]
                     (let [{:keys [title content routes]} (->clj data)]
                       (mutate {:title title
                                :content content
                                :routes routes})))
                   [mutate])]

    ($ ocp
       {:title "Create Announcement"
        :footer ($ ocp-footer {:formState formState :getValues getValues})
        :on-submit (handleSubmit on-submit)}
       ($ form-field
          {:label "Title"
           :data-testid :announcement-ocp--title}
          ($ form/form-text-field
             {:name "title"
              :control control
              :rules #js {:required "This field is required"
                          :maxLength #js {:value 255
                                          :message "Title must be 255 characters or less"}}
              :controller-props #js {:placeholder "e.g., New Feature Release"
                                     :data-testid "announcement-title-input"}}))
       ($ form-field
          {:label "Content (Markdown)"
           :data-testid :announcement-ocp--content}
          ($ rhf/Controller
             {:name "content"
              :control control
              :rules #js {:required "This field cannot be empty"}
              :render (fn [^js props]
                        (let [{{:keys [onChange value onBlur ref]} :field
                               {:keys [error]} :fieldState} (->clj props)]
                          ($ TextField
                             {:value (or value "")
                              :onChange onChange
                              :onBlur onBlur
                              :inputRef ref
                              :error (boolean error)
                              :helperText (when error (:message error))
                              :multiline true
                              :rows 10
                              :fullWidth true
                              :placeholder "Supports **markdown** formatting\n\n## Headers\n- Lists\n- [Links](url)"
                              :data-testid "announcement-content-input"})))}))
       ($ form-field
          {:label "Target Routes"
           :helper-text "Leave empty to show on all routes"
           :data-testid :announcement-ocp--routes}
          ($ rhf/Controller
             {:name "routes"
              :control control
              :render (fn [^js props]
                        (let [{{:keys [error]} :fieldState
                               {:keys [onChange value] :as field} :field} (->clj props)]
                          ($ Autocomplete
                             (spread-props
                              field
                              {:multiple true
                               :options (available-routes)
                               :value (clj->js (or value []))
                               :onChange (fn [_ new-value]
                                           (onChange new-value))
                               :renderTags (fn [values getTagProps]
                                             (to-array
                                              (map-indexed
                                               (fn [idx route]
                                                 (let [^js tag-props (getTagProps #js {:index idx})]
                                                   ($ Chip (spread-props
                                                            tag-props
                                                            {:key route
                                                             :label route
                                                             :size "small"}))))
                                               values)))
                               :renderInput (fn [^js params]
                                              ($ TextField
                                                 (spread-props
                                                  params
                                                  #js {:placeholder "Select routes..."
                                                       :error (boolean error)
                                                       :helperText (:message error)})))}))))})))))

(defocp announcement-create-ocp :announcement/create [_]
  ($ announcement-ocp))
